@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'account.back-button-text' | translate }}</p>
    </div>
  </div>
}

<div class="page-name">
  <h3>{{ 'change-password.title' | translate }}</h3>
</div>

<div class="block">
  <div class="row">
    <div class="title">
      <p class="subtitle-14">{{ 'change-password.old-password-title' | translate }}</p>
    </div>

    <div class="input">
      <input
        class="input"
        [type]="showOldPassword ? 'text' : 'password'"
        placeholder="{{ 'change-password.old-password-placeholder' | translate }}"
        [(ngModel)]="oldPassword"
        />
        <mat-icon svgIcon="eye" [class.active]="showOldPassword"
        (click)="$event.stopPropagation(); showOldPassword = !showOldPassword"></mat-icon>
      </div>
      <div class="subrow forgot-password-container">
        <button class="button link text-button-small"
          (click)="forgotPassword()">{{ 'change-password.forgot-password' | translate }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="title">
        <p class="subtitle-14">{{ 'change-password.new-password-title' | translate }}</p>
      </div>

      <div class="input">
        <input
          class="input"
          [type]="showNewPassword ? 'text' : 'password'"
          placeholder="{{ 'change-password.new-password-placeholder' | translate }}"
          [(ngModel)]="newPassword"
          />
          <mat-icon svgIcon="eye" [class.active]="showNewPassword"
          (click)="$event.stopPropagation(); showNewPassword = !showNewPassword"></mat-icon>

        </div>
      </div>

      <div class="row">
        <div class="title">
          <p class="subtitle-14">{{ 'change-password.confirm-password-title' | translate }}</p>
        </div>

        <div class="input">
          <input
            class="input"
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="{{ 'change-password.confirm-password-placeholder' | translate }}"
            [(ngModel)]="confirmPassword"
            />
            <mat-icon svgIcon="eye" [class.active]="showConfirmPassword"
            (click)="$event.stopPropagation(); showConfirmPassword = !showConfirmPassword"></mat-icon>
          </div>
        </div>

        <div class="row">
          @for (error of errors; track error) {
            <div class="error">
              <p class="body-12 error">{{ error | translate }}</p>
            </div>
          }
        </div>

        <ul class="row password-requirements">
          <li class="body-12 password-requirement-item">{{ 'change-password.password-requirements.length' | translate }}</li>
          <li class="body-12 password-requirement-item">{{ 'change-password.password-requirements.number' | translate }}</li>
          <li class="body-12 password-requirement-item">{{ 'change-password.password-requirements.special' | translate }}</li>
          <li class="body-12 password-requirement-item">{{ 'change-password.password-requirements.uppercase' | translate }}
          </li>
          <li class="body-12 password-requirement-item">{{ 'change-password.password-requirements.lowercase' | translate }}
          </li>
        </ul>
      </div>

      <div class="flex-placeholder"></div>

      <div class="actions">
        <button class="button secondary" (click)="navigateBack()">
          {{ 'change-password.cancel-button' | translate }}
        </button>

        <button class="button primary" (click)="saveChanges()">
          {{ 'change-password.save-button' | translate }}
        </button>
      </div>
